import { render } from "./TemplateBuilder.vue?vue&type=template&id=796c18dc"
import script from "./TemplateBuilder.vue?vue&type=script&lang=js"
export * from "./TemplateBuilder.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__